module.exports = __webpack_public_path__ + "static/Absence-e2f6277f8c16eb176d61743846dc79d9.mp3";